// MobileChargeTab.jsx — 휴대폰 '1:1급여 정산' 탭 (2026-10-06 UX 4단계)
//   목록 화면: 진행 상태 카드 → 직원 목록(누르면 상세) / 상세 화면: [← 목록] → 직원 상세
//   확정 버튼은 화면 아래 고정 칸. 계산·넣기/빼기·확정은 PC와 같은 calc 훅.
import React, { useState } from 'react';
import { ChargeStatusCard } from '../ChargeStatusCard';
import { ChargeList, filterRows } from '../ChargeList';
import { ChargeReviewDetail } from '../ChargeReviewDetail';
import { ChargeConfirmDialog } from '../ChargeConfirmDialog';
import { C } from '../charge.styles';
import { M } from './mobile.styles';

// 휴대폰은 공통 틀의 main 이 스크롤한다(AdminLayout) — 화면을 바꾸면 맨 위로
function scrollTop() {
  const main = document.querySelector('main');
  if (main) main.scrollTo({ top: 0 });
}

function MobileConfirmBar({ calc, onRequestConfirm }) {
  const { month } = calc.parsedMonth;
  const pending = calc.pendingChargeCount;
  const blocked = !calc.rows.length || pending > 0 || calc.loading;
  return (
    <div style={M.bottomBar}>
      {!calc.isConfirmed && pending > 0 && (
        <div style={M.bottomReason}>확인 필요 {pending}건을 먼저 정리해야 확정할 수 있어요.</div>
      )}
      <div style={M.bottomRow}>
        <button type="button" style={{ ...C.outlineBtn, minHeight: 48 }} onClick={() => calc.reload()} disabled={calc.loading}>
          {calc.loading ? '불러오는 중' : '새로고침'}
        </button>
        {calc.isConfirmed ? (
          <button type="button" style={{ ...C.dangerOutlineBtn, minHeight: 48 }} onClick={calc.handleReopen} disabled={calc.loading}>
            {month}월분 확정 취소
          </button>
        ) : (
          <button type="button" style={{ ...C.primaryBtn(blocked), minHeight: 48, padding: '0 10px' }} onClick={onRequestConfirm} disabled={blocked}>
            {month}월분 확정하고 정산서에 넣기
          </button>
        )}
      </div>
    </div>
  );
}

export function MobileChargeTab({ calc, actions, integratedMenuId = null }) {
  const [view, setView] = useState('list');
  const [filter, setFilter] = useState('all');
  const [confirmOpen, setConfirmOpen] = useState(false);

  function openRow(id) {
    calc.handleSelectRow(id);
    setView('detail');
    scrollTop();
  }

  function backToList() {
    setView('list');
    scrollTop();
  }

  // 정리하기 → 확인 필요만 거르고 첫 직원 상세로 바로(상세의 '다음 확인 필요 직원 →'으로 이어 간다)
  function cleanup() {
    setFilter('pending');
    const first = filterRows(calc.rows, 'pending')[0];
    if (first) openRow(first.assignmentId);
  }

  function requestConfirm() {
    if (calc.canConfirm()) setConfirmOpen(true);
  }

  const error = calc.error && !confirmOpen ? <div style={C.error}>{calc.error}</div> : null;

  return (
    <div style={M.page}>
      {view === 'detail' && calc.selectedRow ? (
        <>
          <button type="button" style={M.backBtn} onClick={backToList}>← 목록</button>
          {error}
          <ChargeReviewDetail
            calc={calc}
            row={calc.selectedRow}
            assignment={calc.selectedAssignment}
            rows={calc.rows}
            onSelect={(id) => { calc.handleSelectRow(id); scrollTop(); }}
            onOpenRules={actions.requestRules}
            integratedMenuId={integratedMenuId}
            touch
          />
        </>
      ) : (
        <>
          <div style={{ ...C.card, overflow: 'hidden' }}>
            <ChargeStatusCard calc={calc} onCleanup={cleanup} onRequestConfirm={requestConfirm} hideActions />
          </div>
          {error}
          <ChargeList
            rows={calc.rows}
            filter={filter}
            onFilter={setFilter}
            selectedId={null}
            onSelect={openRow}
            loading={calc.loading}
          />
        </>
      )}
      <div style={M.bottomSpacer} />
      <MobileConfirmBar calc={calc} onRequestConfirm={requestConfirm} />
      <ChargeConfirmDialog open={confirmOpen} calc={calc} onClose={() => setConfirmOpen(false)} />
    </div>
  );
}
